<template>
  <shared-step-editor-modal
    :open="open"
    :width="490"
    title="Advanced Option"
    closeText="Cancel"
    :confirmText="waiting ? 'Waiting...' : 'Confirm'"
    @confirm="handleConfirm"
    @close="handleClose"
  >
    <div class="modal-send-email__subheader">Changing the link is an advanced option. This will affect the options you have and the way the post is displayed on the social network.</div>
  </shared-step-editor-modal>
</template>

<script>
import SharedStepEditorModal from '../../shared/SharedStepEditorModal';
export default {
  components: {SharedStepEditorModal},
  props: {
    open: Boolean,
  },
  data() {
    return {
      waiting: false
    };
  },
  methods: {
    handleConfirm() {
      this.waiting = true;
      this.$emit('confirm');
    },
    handleClose() {
      this.$emit('close');
    },
  },
  watch: {
    open: {
      immediate: true,
      handler(shown) {        
        if(!shown) this.waiting = false;
      },
    },
  }
};
</script>

<style scoped lang="scss"></style>
